import { render, staticRenderFns } from "./extlinkcards.vue?vue&type=template&id=760ebe46&scoped=true&"
import script from "./extlinkcards.vue?vue&type=script&lang=js&"
export * from "./extlinkcards.vue?vue&type=script&lang=js&"
import style0 from "./extlinkcards.vue?vue&type=style&index=0&id=760ebe46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "760ebe46",
  null
  
)

export default component.exports